import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RequiredLabel } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './checkbox-element.style.js';
import { isChecked, handleMultipleChoiceInput } from '../multiple-choice-input';

// Eventually this should use a legend/fieldset, but there is currently an open nvda bug preventing this from working for screen readers
// NVDA bug: https://github.com/nvaccess/nvda/issues/3321
export class CheckboxElement extends Component {
  handleInput(value, checked) {
    const { response, defaultValue, onChange } = this.props;
    var modifiedValue = handleMultipleChoiceInput(response, defaultValue, value, checked, false);
    onChange(modifiedValue);
  }

  hasValue() {
    const { response, defaultValue } = this.props;
    return response ? response.size > 0 : defaultValue ? defaultValue.size > 0 : false;
  }

  render() {
    const { response, defaultValue, isRequired, hidden, label, tooltip, options, id, disabled, readOnly, errors, showErrors,  css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    if(hidden) return null;

    return (
      <fieldset
        id={id}
        role="group"
        className={css.fieldset}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLabel: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <div className={this.hasValue() ? css.buttons : css.buttonsEmpty}>
          {options.map(option => (
            <div key={`${id}-${option.value}`}>
              <label className={css.buttonLabel} htmlFor={option.id}>
                <input
                  name={'group' + id}
                  id={option.id}
                  className={readOnly ? css.readOnly : css.checkbox}
                  type="checkbox"
                  disabled={disabled}
                  value={option.value}
                  onChange={e => {
                    if(readOnly)
                      return false;
                  return this.handleInput(e.target.value, e.target.checked)
                  }}
                checked={isChecked(response, defaultValue, option.value)}
                  aria-label={label + ' ' + option.label}
                  aria-required={isRequired}
                  aria-invalid={hasErrors && showErrors}
                  aria-describedby={errorIds} />
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    );
  }
}

CheckboxElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  options: PropTypes.array.isRequired,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.any,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (CheckboxElement);
